
import Vue from 'vue';

export default Vue.extend({
    name: 'TaxTable',
    
    props: {
        id: String,
        title: String,
        columnHeadings: Array,
        tableData: Array,
        highlightRows: Array,
    },

    methods: {
        getHeaderCellClasses(colIndex: number): string {
            let classes = ' pvd-table__column-header-cell pvd-table__column-header-cell--center column-width';
            if (colIndex == 0) {
                // attempt to make first column fixed
                // classes += ' pvd-table__column-header-cell--fixed pvd-table__column-header-cell--fixed-first'
            }
            return classes;
        },

        getContentCellClasses(rowIndex: number, colIndex: number): string {
            const highlight = (this.highlightRows as number[]).includes(rowIndex);
            let classes = highlight ? 'highlight-row-color' : rowIndex % 2 == 0 ? 'dark-row-color' : 'light-row-color';
            classes += '  pvd-table__data-cell pvd-table__data-cell--center column-width';
            if (colIndex == 0) {
                classes += ' first-column-bold';
                // attempt to make first column fixed
                // classes += ' pvd-table__data-cell--fixed pvd-table__data-cell--fixed-first';
            }
            return classes;
        },
    },
});
